import TaskCreatedEvent from '@/domains/tasks/events/TaskCreatedEvent';

const TaskEvents = {
  TaskCreated: TaskCreatedEvent,
};

export default TaskEvents;
